import Aos from 'aos';
import 'aos/dist/aos.css'
import './App.css';
import PageRouting from './pageRouting/Index';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

function App() {
  

  useEffect(() => {
    Aos.init({
      duration: 1500,
      offset: 200,
      once: true,
  });
  }, [])

  return (
    <div className="App ">
      <BrowserRouter>
     <PageRouting/>
     </BrowserRouter>
    </div>
  );
}

export default App;
